import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import interviewReducer from '../features/interview/interviewSlice';
import upcomingSessionReducer from '../features/upcoming_sessions/upcomingSessionSlice';
import challengeReducer from '../features/challenges/challengeSlice';
import aiTipReducer from '../features/ai_tips/aiTipSlice';

import { tokenMiddleware } from '../features/auth/authMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    interview: interviewReducer,
    upcomingSession: upcomingSessionReducer,
    challenge: challengeReducer,
    aiTip: aiTipReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(tokenMiddleware),
});
